import { MeshStandardMaterial } from "three";
import { FrontSide } from "three";
import { TypedMatNode } from "./_Base";
import { NodeParamsConfig } from "../utils/params/ParamsConfig";
import { ColorsController, ColorParamConfig } from "./utils/ColorsController";
import { AdvancedCommonController, AdvancedCommonParamConfig } from "./utils/AdvancedCommonController";
import { TextureMapController, MapParamConfig } from "./utils/TextureMapController";
import { TextureAlphaMapController, AlphaMapParamConfig } from "./utils/TextureAlphaMapController";
import { TextureEnvMapController, EnvMapParamConfig } from "./utils/TextureEnvMapController";
import { TextureBumpMapController, BumpMapParamConfig } from "./utils/TextureBumpMapController";
import { TextureNormalMapController, NormalMapParamConfig } from "./utils/TextureNormalMapController";
import { TextureEmissiveMapController, EmissiveMapParamConfig } from "./utils/TextureEmissiveMapController";
import {
  TextureMetalnessRoughnessMapController,
  MetalnessRoughnessMapParamConfig
} from "./utils/TextureMetalnessRoughnessMapController";
import { TextureLightMapController, LightMapParamConfig } from "./utils/TextureLightMapController";
import { TextureDisplacementMapController, DisplacementMapParamConfig } from "./utils/TextureDisplacementMapController";
import { TextureAOMapController, AOMapParamConfig } from "./utils/TextureAOMapController";
import { WireframeController, WireframeParamConfig } from "./utils/WireframeController";
import { FogController, FogParamConfig } from "./utils/FogController";
import { DefaultFolderParamConfig } from "./utils/DefaultFolder";
import { TexturesFolderParamConfig } from "./utils/TexturesFolder";
import { AdvancedFolderParamConfig } from "./utils/AdvancedFolder";
class MeshStandardMatParamsConfig extends FogParamConfig(WireframeParamConfig(AdvancedCommonParamConfig(AdvancedFolderParamConfig(MetalnessRoughnessMapParamConfig(NormalMapParamConfig(LightMapParamConfig(EnvMapParamConfig(EmissiveMapParamConfig(DisplacementMapParamConfig(BumpMapParamConfig(AOMapParamConfig(AlphaMapParamConfig(MapParamConfig(TexturesFolderParamConfig(ColorParamConfig(DefaultFolderParamConfig(NodeParamsConfig))))))))))))))))) {
}
const ParamsConfig = new MeshStandardMatParamsConfig();
export class MeshStandardMatNode extends TypedMatNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
    this.controllers = {
      advancedCommon: new AdvancedCommonController(this),
      alphaMap: new TextureAlphaMapController(this),
      aoMap: new TextureAOMapController(this),
      bumpMap: new TextureBumpMapController(this),
      displacementMap: new TextureDisplacementMapController(this),
      emissiveMap: new TextureEmissiveMapController(this),
      envMap: new TextureEnvMapController(this),
      lightMap: new TextureLightMapController(this),
      map: new TextureMapController(this),
      metalnessRoughnessMap: new TextureMetalnessRoughnessMapController(this),
      normalMap: new TextureNormalMapController(this)
    };
    this.controllerNames = Object.keys(this.controllers);
  }
  static type() {
    return "meshStandard";
  }
  createMaterial() {
    return new MeshStandardMaterial({
      vertexColors: false,
      side: FrontSide,
      color: 16777215,
      opacity: 1,
      metalness: 1,
      roughness: 0
    });
  }
  initializeNode() {
    this.params.onParamsCreated("init controllers", () => {
      for (let controllerName of this.controllerNames) {
        this.controllers[controllerName].initializeNode();
      }
    });
  }
  async cook() {
    for (let controllerName of this.controllerNames) {
      this.controllers[controllerName].update();
    }
    ColorsController.update(this);
    FogController.update(this);
    WireframeController.update(this);
    this.setMaterial(this.material);
  }
}
